import { useInfiniteQuery, useQueryClient } from '@tanstack/react-query'
import moment from 'moment'
import { useCallback, useMemo } from 'react'
import { gameBoxRoomService } from '../../../../services/games/games-boxes-rooms'
import type { GetList } from '../../../../services/games/games-boxes-rooms/types'

export const GAMES_BOXES_ROOMS_QUERY_KEY = 'getGamesBoxesRooms'

export const useGetGamesBoxesRooms = (params: GetList.Input) => {
  const queryClient = useQueryClient()

  const currentDate = useMemo(() => {
    return moment().add(10, 'minutes').format('YYYY-MM-DD HH:mm:ss')
  }, [])

  const { data, isFetchingNextPage, isLoading, fetchNextPage } =
    useInfiniteQuery({
      queryKey: [
        GAMES_BOXES_ROOMS_QUERY_KEY,
        { ...params, dateInitialDistribute: currentDate },
      ],
      initialPageParam: 0,
      queryFn: ({ pageParam: skip }) => {
        return gameBoxRoomService.getList({
          ...params,
          take: 20,
          skip,
          closed: false,
          dateInitialDistribute: currentDate,
          typeFilterDateDistribute: 'lessEqual',
        })
      },
      getNextPageParam: (lastPage, _allPages, lastPageParam) => {
        if (lastPage?.error) return null

        if (lastPage && !lastPage?.data?.length) return null

        return lastPageParam + 1
      },
    })

  const refetch = useCallback(() => {
    queryClient.invalidateQueries({
      queryKey: [
        GAMES_BOXES_ROOMS_QUERY_KEY,
        { ...params, dateInitialDistribute: currentDate },
      ],
    })
  }, [params, queryClient, currentDate])

  return {
    gamesBoxesRooms: data?.pages?.flatMap((page) => page?.data),
    isFetchingNextPage,
    isLoading,
    nextPage: fetchNextPage,
    refetch,
  }
}
